<template>
  <div class="map">
    <div ref="mapPanelTop" class="absolute top-0"></div>
    <div
      v-show="(showMapPanel || showSearchPanel) && !showStreetView"
      class="z-10 w-full"
      :class="showMapPanel ? 'absolute' : 'sticky'">
      <search-form
        @search="onSearch"
        @incrementSearch="onIncrementSearch"
        @closeSearchPanel="onCloseSearchPanel"
        @openFilterPanel="onOpenFilterPanel"
        @openGenreList="onOpenGenreList"
        @clearForm="clearFrom"
        :onSearch="showSearchPanel"
      />
    </div>
    <div v-show="showMapPanel" class="h-full w-full">
      <map-panel
        ref="mapPanel"
        @search="onSearch"
        @closeSearchPanel="onCloseSearchPanel"
        @openFilterPanel="onOpenFilterPanel"
        :zoomLevel="zoomLevel"
      />
    </div>
    <div v-if="showSearchPanel && !showStreetView" class="h-full w-full pb-4">
      <search-panel
        @selectGenre="onSelectGenre"
        @closeSearchPanel="onCloseSearchPanel"
        @clearForm="clearFrom"
        :genre="genre"
        :searchWord="searchWord"
        searchType="Departure"
      />
    </div>
    <div v-if="showGenreList" class="h-full w-full pb-4">
      <genre-list
        @close="onCloseGenreList"
        @selectGenre="onSelectGenre"
      />
    </div>
    <div v-show="showFilterPanel" class="h-full w-full pb-4">
      <filter-panel
        @close="onCloseFilterPanel"
      />
    </div>
    <div v-show="showDocomoMobaku" class="h-full w-full pb-4">
      <docomo-mobaku/>
    </div>
    <street-view @onStreetView="onStreetView" :showStreetView="showStreetView" ref="streetView" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

import SearchForm from '../components/organisms/Map/SearchForm'
import SearchPanel from '../components/organisms/Map/SearchPanel'
import GenreList from '../components/organisms/Map/GenreList'
import FilterPanel from '../components/organisms/Map/FilterPanel'
import MapPanel from '../components/organisms/Map/MapPanel'
import DocomoMobaku from '../components/organisms/Map/DocomoMobaku'
import StreetView from '../components/organisms/Map/StreetView'
import Constants from '../constants'

export default {
  created () {
    if (this.$route.params.latLng) {
      // 指定された緯度経度を中心
      this.$store.dispatch('map/updateCenterLatLng', this.$route.params.latLng)
    }
    this.$store.dispatch('loading/beginLoading')
    this.$store.dispatch('drawer/close')
    this.$store.dispatch('busLocation/close')
    this.$store.dispatch('genres/fetchAll')
      .then(() => {
        this.$store.dispatch('places/fetchAll')    
          .then(() => {
            this.$refs.mapPanel.mapInitialized()
            const poiId = this.$route.params.poiId || this.$route.params.areaId
            if (poiId !== undefined && this.$route.name === 'map' && Constants.MX1_ORAGA_LOGO_LIST[poiId] === undefined) {
              const place = this.$store.getters['places/getPlace'](poiId)
              if (place) {
                this.$gtag.event("POI詳細表示", {
                  poi_id: place.id,
                  poi_name: place.name
                });
                this.$store.dispatch('drawer/openPlace', { place: place, full: true })
              } else {
                this.$store.dispatch('drawer/updateSelectedPlace', {})
              }
            } else {
              // ジャンル指定
              if (this.$route.params.tagId !== undefined) {
                this.$store.dispatch('user/offFilterAll')
                const genre = this.$store.getters['genres/getGenreFromId'](this.$route.params.tagId)
                this.$store.dispatch('user/onFilter', genre)
                this.isOpenSearchPanel = false
              } else if (this.$route.name == 'current') {
                // 現在地中心
                if (!navigator.geolocation) {
                  alert(this.$t('map_location_error_message'))
                  return
                }
                this.$store.dispatch('geolocation/fetchLocation')
                  .then(() => {
                    const fromLocation = this.$store.getters['geolocation/getLocation']
                    const center  = {
                      lat: fromLocation.lat,
                      lng: fromLocation.lng
                    }
                    this.$store.dispatch('map/updateCenter', center)
                  })
                  .catch(() => {
                    const errorCode = this.$store.getters['geolocation/getErrorCode']
                    this.handleError(errorCode)
                  })
              }
              this.$store.dispatch('drawer/updateSelectedPlace', {})
            }
            // お気に入り施設の取得
            if (this.token) {
              this.$store.dispatch('favorites/fetchAll').then(() => {
                const favoriteGenre = this.$store.getters['genres/getFavoriteGenre']
                if (favoriteGenre !== undefined) {
                  const favorites = this.$store.getters['favorites/getFavorites']
                  for (var i = 0; i < favorites.length; i++) {
                    this.$store.dispatch('places/updateFavoritePlace', { id: favorites[i], favoriteId: favoriteGenre.id, favorited: true, favoriteIcon: favoriteGenre.filterIcon})
                  }
                  const genres = this.$store.getters['genres/getAll']
                  this.$store.dispatch('user/updateFilter', genres)
                }
              })
            }
          })
        .finally(() => {
          this.$store.dispatch('loading/endLoading')
        })
      })
      this.$store.dispatch('drawer/showButton')
  },
  components: {
    SearchForm,
    SearchPanel,
    GenreList,
    FilterPanel,
    MapPanel,
    DocomoMobaku,
    StreetView
  },
  data () {
    return {
      showMapPanel: true,
      showSearchPanel: false,
      showGenreList: false,
      showFilterPanel: false,
      showDocomoMobaku: false,
      showBusLocation: false,
      genre: {},
      searchWord: '',
      mobakuMessage: false,
      zoomLevel: 15,
      showFilterMenu: true,
      isOpenSearchPanel: true,
      showStreetView: false
    }
  },
  methods: {
    onSearch: function () {
      this.showSearchPanel = true
      this.showPlaceList = false
      this.showMapPanel = false
      this.showFilterMenu = false
    },
    onCloseSearchPanel: function () {
      this.showSearchPanel = false
      this.showMapPanel = true
      this.genre = {}
      this.showFilterMenu = true
    },
    onOpenGenreList: function () {
      this.showMapPanel = false
      this.showSearchPanel = false
      this.showGenreList = true
    },
    onCloseGenreList: function () {
      this.showGenreList = false
      this.showSearchPanel = false
      this.showMapPanel = true
    },
    onOpenFilterPanel: function () {
      this.showFilterPanel = true
      this.showSearchPanel = false
      this.showMapPanel = false
    },
    onCloseFilterPanel: function () {
      this.showMapPanel = true
      this.showFilterPanel = false
      var genres = this.$store.getters['user/getFilter']
      if (genres["mobaku"]) {
        this.$store.dispatch('googleMap/onDocomoMobaku')
        if(!this.mobakuMessage){
          this.mobakuMessage = true
          this.$store.dispatch('map/setShowDocomoMobaku', true)
        }
      } else {
        this.$store.dispatch('googleMap/offDocomoMobaku')
        this.mobakuMessage = false
      }
    },
    onSelectGenre: function (genre) {
      this.genre = genre
      this.showGenreList = false
      this.showSearchPanel = true
      this.$refs['mapPanelTop'].scrollIntoView({ behavior: 'smooth'})
    },
    onIncrementSearch: function (word) {
      this.searchWord = word
    },
    handleError: function (errorCode) {
      switch (errorCode) {
        case 1: //PERMISSION_DENIED
          alert(this.$t('map_permission_denied_error_message'))
          break
        case 2: //POSITION_UNAVAILABLE
          alert(this.$t('map_position_unavailable_error_message'))
          break
        case 3: //TIMEOUT
          alert(this.$t('map_timeout_error_message'))
          break
        default:
          alert(this.$t('map_default_error_message'))
          break
      }
    },
    getPlaces: function () {
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('places/fetchAll')
        .then(() => {
          const genres = this.$store.getters['genres/getAll']
          this.$store.dispatch('user/updateFilter', genres)
          if (this.token) {
            const favoriteGenre = this.$store.getters['genres/getFavoriteGenre']
            if (favoriteGenre !== undefined) {
              const favorites = this.$store.getters['favorites/getFavorites']
              for (var i = 0; i < favorites.length; i++) {
                this.$store.dispatch('places/updateFavoritePlace', { id: favorites[i], favoriteId: favoriteGenre.id, favorited: true, favoriteIcon: favoriteGenre.filterIcon})
              }
              this.$store.dispatch('user/updateFilter', genres)
            }
          }
          this.$store.dispatch('loading/endLoading')
        })
    },
    openSearchPanel: function () {
      this.isOpenSearchPanel = true
      this.$store.dispatch('busLocation/close')
    },
    initMap: function () {
      this.map.addListener("drag", () => {
        this.isOpenSearchPanel = false
      })
      this.$refs.streetView.init()
    },
    clearFrom: function () {
      this.$store.dispatch('map/clearSearchFrom')
      this.searchWord=''
    },
    onStreetView:function (isShow) {
      this.showStreetView = isShow
    }
  },
  computed: {
    ...mapGetters({
      center: 'map/getCenter',
      selectedPlace: 'drawer/getSelectedPlace',
      showPlaceFull: 'drawer/getShowPlaceFull',
      token: 'user/getToken',
      docomoMobakuOn: 'map/getShowDocomoMobaku',
      map: 'googleMap/getMap',
      searchFrom: 'map/getSearchFrom'
    })
  },
  watch: {
    selectedPlace: function (val) {
      if (!_.isEmpty(val)) {
        this.showSearchPanel = false
        this.showMapPanel = true
        this.showBusLocation = false
        this.showFilterMenu = true
        this.isOpenSearchPanel = false
      }
    },
    showPlaceFull: function (val) {
      if (val && this.isOpenSearchPanel) {
        this.isOpenSearchPanel = false
      }
    },
    docomoMobakuOn: function (val) {
      this.showDocomoMobaku = val
    },
    selectedBusStops: function (val) {
      if (!_.isEmpty(val)) {
        this.showMapPanel = true
        this.isOpenSearchPanel = false
      }
    },
    searchFrom: function (val) {
      this.from = val
      this.isOpenSearchPanel = true
    },
    busLocationIsOpen: function (val) {
      this.showBusLocation = val
    },
    map: function () {
      this.initMap()
    },
    center: function (val) {
      if (!_.isEmpty(this.map)) {
        this.map.panTo(val)
      }
    }
  }
}
</script>
